<!--
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-05-13 17:32:56
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-05-14 14:50:26
 -->
<template>
  <van-field
    v-model="input_value"
    :type="input_type"
    clearable
    :placeholder="placeholder"
    :border="input_border"
    :left-icon="eye"
    @click-left-icon="handleEye"
    @input="$emit('input', $event)"
  />
</template>
<script>
import { Field, Icon } from "vant";
export default {
  name: "password-input",
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "请填写6位以上数字+字母的密码"
    },
    input_border: {
      type: Boolean,
      default: false
    }
  },
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field
  },
  data() {
    return {
      input_value: this.value,
      input_type: "password",
      eye: "closed-eye" //闭眼
    };
  },
  methods: {
    //控制密码是否可见
    handleEye() {
      if (this.eye == "closed-eye") {
        this.eye = "eye-o";
        this.input_type = "text";
      } else {
        this.eye = "closed-eye";
        this.input_type = "password";
      }
    }
  }
};
</script>